import * as Icons from '@ant-design/icons';
import ContentModal from 'components/modal/ContentModal';
import ContentModalV2 from 'components/modal/ContentModalV2';
import DeleteModal from 'components/modal/DeleteNodeModal';
import React, { useMemo } from 'react';
import RequirementNodeModal from 'components/modal/RequirementNodeModal';
import { IClassroom } from 'interfaces/classrooms';
import { IDataContent, IDataNode } from 'interfaces/courses';
import { getTenant } from 'services/tenants';
import { useModal } from '@refinedev/core';

const tenant = getTenant();

const contentsModalV1Disabled =
  tenant.disabledFeatures?.includes('contents_modal_v1');

interface NodeProps {
  node: IDataNode;
  updateNode: (node: IDataNode) => void;
  onRemove: (node: IDataNode) => void;
  updateNodeContent: (node: IDataContent) => void;
  classroom: IClassroom;
}

const Node: React.FC<NodeProps> = ({
  node,
  classroom,
  onRemove,
  updateNode,
  updateNodeContent
}) => {
  const nodeModal = useModal();
  const contentModal = useModal();
  const deleteModal = useModal();

  const nodeModalOpened = useMemo(() => nodeModal.visible, [nodeModal]);
  const contentModalOpened = useMemo(
    () => contentModal.visible,
    [contentModal]
  );

  // TODO refactor modals for each node
  return (
    <div className="flex gap-2 items-center">
      <span className={node.isLeaf ? 'font-normal' : 'font-medium'}>
        {node.title as string}
      </span>

      <Icons.EditOutlined
        onClick={() => {
          node.isLeaf ? contentModal.show() : nodeModal.show();
        }}
      />

      <Icons.DeleteOutlined
        onClick={() => {
          deleteModal.show();
        }}
      />

      {(!contentsModalV1Disabled || (node as IDataContent).core_id) &&
        node.isLeaf &&
        contentModalOpened && (
          <ContentModal
            modal={contentModal}
            node={node as IDataContent}
            onUpdate={updateNodeContent}
            classroomId={classroom.id}
            requirements={classroom.requirements}
          />
        )}

      {contentsModalV1Disabled &&
        !(node as IDataContent).core_id &&
        node.isLeaf &&
        contentModalOpened && (
          <ContentModalV2
            modal={contentModal}
            node={node as IDataContent}
            onUpdate={updateNodeContent}
            classroomId={classroom.id}
            requirements={classroom.requirements}
          />
        )}

      {!node.isLeaf && nodeModalOpened && (
        <RequirementNodeModal
          modal={nodeModal}
          node={node}
          onUpdate={updateNode}
          unit={{
            kind: 'classroom',
            id: classroom.id,
            requirements: classroom.requirements
          }}
        />
      )}

      <DeleteModal modal={deleteModal} node={node} onUpdate={onRemove} />
    </div>
  );
};

export default Node;
